<div class="rounded-lg relative z-2" [ngClass]="addCustomClass ? addCustomClass : ''">

  <div class="" [ngClass]="addHeaderCustomClass  ? addHeaderCustomClass  : ''" (click)="toggleContent()">
    <!--  border-[#CED4DA]  -->
    <div class="w-full " >
      <ng-content select="[header]"></ng-content>
    </div>
  </div>

  <div class="dropdown-body transition duration-300 overflow-y-hidden max-h-0 " [ngClass]="{'max-h-[fit-content] overflow-y-visible open-animation': isOpen }">
    <ng-content select="[content]"></ng-content>
  </div>

</div>
